module.exports = __webpack_public_path__ + "static/WS_appflows_virtual_2-71dbbb1fb58bb45070e6dc728e2b34ee.gif";